var React = require('react');

function Oval (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M329.5 67C329.5 76.0718 324.974 84.7628 316.687 92.7187C308.399 100.676 296.379 107.865 281.484 113.913C251.699 126.008 210.515 133.5 165 133.5C119.485 133.5 78.3014 126.008 48.5155 113.913C33.6213 107.865 21.6013 100.676 13.3128 92.7187C5.02566 84.7628 0.5 76.0718 0.5 67C0.5 57.9282 5.02566 49.2372 13.3128 41.2813C21.6013 33.324 33.6213 26.1351 48.5155 20.0871C78.3014 7.99224 119.485 0.5 165 0.5C210.515 0.5 251.699 7.99224 281.484 20.0871C296.379 26.1351 308.399 33.324 316.687 41.2813C324.974 49.2372 329.5 57.9282 329.5 67Z","stroke":"#3E4F19"}));
}

Oval.defaultProps = {"width":"330","height":"134","viewBox":"0 0 330 134","fill":"none"};

module.exports = Oval;

Oval.default = Oval;
